// extracted by mini-css-extract-plugin
export var attachment = "_k3-a";
export var emailContainer = "_k3-4";
export var emailContentPaddedContainer = "_k3-b";
export var emailHeader = "_k3-6";
export var emailIframe = "_k3-3";
export var emailInfoIcon = "_k3-9";
export var emailShortenedSummary = "_k3-e";
export var infoDropdown = "_k3-0";
export var infoRowBoundedContent = "_k3-d";
export var internal = "_k3-5";
export var merchant = "_k3-8";
export var messageInputContainer = "_k3-h";
export var normal = "_k3-7";
export var replyCard = "_k3-f";
export var subtleButton = "_k3-1";
export var subtleButtonIconContainer = "_k3-2";
export var toggleViewRepliesButton = "_k3-c";
export var wrappingText = "_k3-g";